// Runtime-first config.
//
// These values are read at RUNTIME from `window.__ENV__`, which `server.js`
// injects into index.html from the app's Heroku config vars on every request.
// They take precedence over the build-time `process.env` values baked by
// dotenv-webpack.
//
// Why (roadmap#1754): the URLs used to be baked into the bundle at build time.
// Combined with the Heroku pipeline (a promote copies the *compiled slug* of
// the staging app), a promote carried the staging-built bundle — with
// `hsm-backend.stagecliengo.com` hardcoded — to production. The prod iframe
// then fetched the line list from STAGE, got an empty list, and showed the
// "no campaigns" landing for every account on the new backend. The prod config
// var was correct, but it does not re-bake an already-compiled bundle.
// Resolving at runtime makes a single slug correct in any environment, so
// promotes are safe. The `process.env` values remain a fallback for local dev.

type RuntimeEnvKey =
  | 'APP_NAME'
  | 'LOGIN_URL'
  | 'MOCKED_AUTH'
  | 'HSM_BACKEND_URL'
  | 'LAUNCH_DARKLY_CLIENT_ID'
  | 'CORS_ANYWERE_URL'
  | 'SEGMENT_WRITE_KEY'
  | 'MAIN_HELP_LINK'
  | 'TEMPLATE_HELP_LINK';

declare global {
  interface Window {
    __ENV__?: Partial<Record<RuntimeEnvKey, string>>;
  }
}

const runtime: Partial<Record<RuntimeEnvKey, string>> =
  (typeof window !== 'undefined' && window.__ENV__) || {};

export const APP_NAME: string =
  runtime.APP_NAME || process.env.APP_NAME || 'ts-hsm-manager';

export const LOGIN_URL: string =
  runtime.LOGIN_URL ||
  process.env.LOGIN_URL ||
  'https://www.login.stagecliengo.com';

export const MOCKED_AUTH: boolean =
  (runtime.MOCKED_AUTH || process.env.MOCKED_AUTH) === 'true' || false;

export const HSM_BACKEND_URL: string =
  runtime.HSM_BACKEND_URL ||
  process.env.HSM_BACKEND_URL ||
  'https://hsm-backend.stagecliengo.com';

/**
 * LaunchDarkly client-side ID. Must be the SAME id (per environment) that
 * rapidash uses, so hsm-frontend evaluates flags against the same LD
 * environment — that is what makes `feature-segments` the one shared flag.
 *
 * Intentionally NOT defaulted to a concrete environment's id: a hardcoded
 * stage id would turn the `if (!LAUNCH_DARKLY_CLIENT_ID) return false` no-op
 * guard in `launch-darkly-client.ts` into dead code, so a prod build that
 * forgot to inject the prod id would silently evaluate flags against STAGE
 * (fail-wrong). Empty = fail-closed: LD stays a no-op and the feature stays
 * hidden until the id is provided. Deploy requirement: set
 * `LAUNCH_DARKLY_CLIENT_ID` in EVERY environment (dev/stage/prod) to rapidash's
 * id for that same environment. Now resolved at runtime too (see top of file),
 * which also removes the promote-carries-stage-id failure mode.
 */
export const LAUNCH_DARKLY_CLIENT_ID: string =
  runtime.LAUNCH_DARKLY_CLIENT_ID || process.env.LAUNCH_DARKLY_CLIENT_ID || '';

export const CORS_ANYWERE_URL: string =
  runtime.CORS_ANYWERE_URL ||
  process.env.CORS_ANYWERE_URL ||
  'https://cliengo-cors-anywere-8b605de04889.herokuapp.com/';

export const SEGMENT_WRITE_KEY: string =
  runtime.SEGMENT_WRITE_KEY ||
  process.env.SEGMENT_WRITE_KEY ||
  '7WHI36JKuhdMtRxpJ0XmEivgGQzIztLN';

export const MAIN_HELP_LINK: string =
  runtime.MAIN_HELP_LINK ||
  process.env.MAIN_HELP_LINK ||
  'https://help.cliengo.com/hc/es/articles/8888445953051-Mensajes-salientes-de-WhatsApp-Business-HSMs-con-Cliengo';

export const TEMPLATE_HELP_LINK: string =
  runtime.TEMPLATE_HELP_LINK ||
  process.env.TEMPLATE_HELP_LINK ||
  'https://help.cliengo.com/hc/es/articles/19859693508763';
